import { paths } from './../types';
import { FetchOptions } from 'openapi-fetch';
import type {
  FilterKeys,
  PathsWithMethod,
  HasRequiredKeys,
  HttpMethod
} from 'openapi-typescript-helpers';

// eslint-disable-next-line @typescript-eslint/ban-types
type CreateTypedGetQueryKey<Paths extends {}> = {
  getTypedQueryKey<T extends HttpMethod, P extends PathsWithMethod<Paths, T>>(
    url: P,
    ...options: HasRequiredKeys<
      FetchOptions<FilterKeys<Paths[P], T>>
    > extends never
      ? [(FetchOptions<FilterKeys<Paths[P], T>> | undefined)?]
      : [FetchOptions<FilterKeys<Paths[P], T>>]
  ): string[];
};

export const createGetQueryKey: CreateTypedGetQueryKey<paths> = {
  getTypedQueryKey(url, ...options) {
    // @ts-expect-error Params does exist sometimes
    return [url, options[0]?.body, options[0]?.params];
  }
};

export const getTypedQueryKey = createGetQueryKey.getTypedQueryKey;
